import {ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {NotFoundComponent} from './not-found/not-found.component';
import {HelpComponent} from './help/help.component';

const appRoutes: Routes = [
  {path: '', pathMatch: 'full', component: HelpComponent},
  {path: 'not-found', component: NotFoundComponent},
  {path: '**', redirectTo: 'not-found'}
];

export const appRouting: ModuleWithProviders = RouterModule.forRoot(appRoutes);




// WEBPACK FOOTER //
// ./src/app/app.routing.ts